import { BrowserRouter, Routes, Route } from 'react-router';
import { Toaster } from 'sonner';
import { Registration } from './pages/Registration';
import { QueueWaiting } from './pages/QueueWaiting';
import { Consultation } from './pages/Consultation';
import { Feedback } from './pages/Feedback';
import { ErrorBoundary } from './components/ErrorBoundary';

export function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Registration />} />
          <Route path="/queue" element={<QueueWaiting />} />
          <Route path="/consultation" element={<Consultation />} />
          <Route path="/feedback" element={<Feedback />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        richColors
        closeButton
        toastOptions={{
          duration: 4000,
          style: {
            background: '#1e293b',
            border: '1px solid #334155',
            color: '#f1f5f9',
          },
        }}
      />
    </ErrorBoundary>
  );
}
